module.exports = __webpack_public_path__ + "static/educaffe-founder-8b5c7f70672ae0638e764d19a4218014.png";